<template>
  <Card class="layout-card" style="height: 100%">
    <div class="header-container">
      <div class="search-form">
        <MultiCascader
          v-model="searchForm.countryCodes"
          :data="countryLi"
          placeholder="请选择国家"
          style="width: 250px"
        />
        <Select
          v-model="searchForm.langIds"
          multiple
          filterable
          placeholder="请选择语言"
          :max-tag-count="1"
        >
          <Option v-for="item in langOptions" :key="item.id" :value="item.id">{{
            item.langName
          }}</Option>
        </Select>
        <Select
          v-model="searchForm.registerTimeKey"
          placeholder="请选择注册时间"
          multiple
          :max-tag-count="1"
        >
          <Option
            v-for="item in registerTimeOptions"
            :key="item.key"
            :value="item.key"
            >{{ item.label }}</Option
          >
        </Select>
        <Select
          v-model="searchForm.payTypes"
          multiple
          placeholder="请选择付费类型"
          :max-tag-count="1"
        >
          <Option
            v-for="item in payTypeOptions"
            :key="item.dictValue"
            :value="Number(item.dictValue)"
            >{{ item.dictName }}</Option
          >
        </Select>
        <Select
          v-model="searchForm.deviceSys"
          placeholder="请选择操作设备"
          clearable
        >
          <Option :value="0">iOS</Option>
          <Option :value="1">安卓</Option>
        </Select>
        <MultiCascader
          v-model="searchForm.channels"
          :data="channelOptions"
          placeholder="请选择渠道"
          style="width: 200px"
        />
        <Select
          v-model="searchForm.todayLogin"
          placeholder="当日是否登录"
          clearable
        >
          <Option :value="1">是</Option>
          <Option :value="0">否</Option>
        </Select>
        <Select
          v-model="searchForm.usageScene"
          placeholder="请选择使用场景"
          clearable
        >
          <Option :value="1">弹窗推送</Option>
          <Option :value="2">三方支付</Option>
          <Option :value="3">广告策略</Option>
          <Option :value="4">ab测试</Option>
          <Option :value="6">活动H5推送</Option>
          <Option :value="7">充值面板</Option>
        </Select>
      </div>
      <div class="search-row-bottom">
        <Select
          v-model="searchForm.userType"
          placeholder="用户类型"
          clearable
          style="width: 120px"
        >
          <Option :value="1">IAA</Option>
          <Option :value="2">IAP</Option>
        </Select>
        <Select
          v-model="searchForm.vipUser"
          placeholder="是否VIP"
          clearable
          style="width: 120px"
        >
          <Option :value="1">是</Option>
          <Option :value="0">否</Option>
        </Select>
        <Input
          v-model="searchForm.name"
          placeholder="请输入人群包名称"
          clearable
          style="width: 250px"
        />
        <Button type="primary" @click="getData(1)">搜索</Button>
        <div style="flex: 1"></div>
        <Button type="success" icon="md-add" @click="handleOpenEditModal()"
          >新增人群包</Button
        >
      </div>
    </div>

    <div class="table-container">
      <Table :data="tableData" :columns="columns" :loading="tableLoading">
        <template #countryNames="{ row }">
          <div>
            <Tooltip
              v-if="row.countryNames"
              style="width: 100%"
              :content="row.countryNames"
              :max-width="300"
              transfer
            >
              <span class="ellipsis-text">{{ row.countryNames }}</span>
            </Tooltip>
            <span v-else>-</span>
          </div>
        </template>
        <template #langNames="{ row }">
          <div>
            <Tooltip
              v-if="row.langNames"
              style="width: 100%"
              :content="row.langNames"
              :max-width="300"
              transfer
            >
              <span class="ellipsis-text">{{ row.langNames }}</span>
            </Tooltip>
            <span v-else>-</span>
          </div>
        </template>
        <template #registerTimeDisplay="{ row }">
          <span>{{ row.registerTimeDisplay || '-' }}</span>
        </template>
        <template #userTypeName="{ row }">
          <span>{{ getUserTypeLabel(row.userType, row.userTypeName) }}</span>
        </template>
        <template #vipUserDesc="{ row }">
          <span>{{ row.vipUser===null?'-':(row.vipUser?'是':'否') }}</span>
        </template>
        <template #payTypeName="{ row }">
          <span>{{ row.payTypeName || '-' }}</span>
        </template>
        <template #deviceSysName="{ row }">
          <span>{{ row.deviceSysName || '-' }}</span>
        </template>
        <template #usage="{ row }">
          <a @click="handleViewUsage(row)">查看</a>
        </template>
        <template #action="{ row }">
          <div class="action-buttons">
            <a @click="handleView(row)">查看</a>
            <a @click="handleOpenEditModal(row)">编辑</a>
            <Poptip confirm title="确认删除该人群包吗？删除后不可恢复。" transfer @on-ok="handleDelete(row)">
              <a>删除</a>
            </Poptip>
          </div>
        </template>
        <template #footer>
          <Pages :page="page" :func="getData"></Pages>
        </template>
      </Table>
    </div>

    <EditModal
      v-model="editVisible"
      :data="editForm"
      :readonly="editReadonly"
      @on-success="getData"
    />

    <UsageDrawer
      v-model="usageVisible"
      :crowdId="usageCrowdId"
      :crowdName="usageCrowdName"
    />
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import EditModal from './EditModal.vue'
import UsageDrawer from './UsageDrawer.vue'
import { getCrowdList, getCrowdInfo, getRegisterTimeOptions, delCrowd } from '@/api/crowd'
import { getDictionaryList } from '@/api/dictionary'
import { getLangList } from '@/api/lang'
import MultiCascader from '@/components/MultiCascader'

const USER_MONETIZATION_LABEL_MAP = {
  1: 'IAA',
  2: 'IAP'
}

export default {
  name: 'CrowdPackageList',
  components: {
    Pages,
    EditModal,
    UsageDrawer,
    MultiCascader
  },
  data() {
    return {
      searchForm: {
        name: '',
        countryCodes: [],
        langIds: [],
        registerTimeKey: null,
        payTypes: [],
        deviceSys: null,
        usageScene: null,
        channels: [],
        todayLogin: null,
        userType: null,
        vipUser: null
      },
      tableLoading: false,
      editVisible: false,
      editReadonly: false,
      editForm: {},
      usageVisible: false,
      usageCrowdId: null,
      usageCrowdName: '',
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      registerTimeOptions: [],
      payTypeOptions: [],
      langOptions: [],
      countryLi: [],
      channelOptions: [],
      columns: [
        {
          title: '人群包名称',
          key: 'name',
          minWidth: 160
        },
        {
          title: '国家',
          slot: 'countryNames',
          minWidth: 100
        },
        {
          title: '语言',
          slot: 'langNames',
          minWidth: 80
        },
        {
          title: '用户类型',
          slot: 'userTypeName',
          minWidth: 100
        },
        {
          title: '用户注册时间',
          slot: 'registerTimeDisplay',
          minWidth: 80
        },
        {
          title: '是否VIP',
          slot: 'vipUserDesc',
          minWidth: 80
        },
        {
          title: '付费类型',
          slot: 'payTypeName',
          minWidth: 80
        },
        {
          title: '操作设备',
          slot: 'deviceSysName',
          minWidth: 50
        },
        {
          title: '使用场景',
          slot: 'usage',
          minWidth: 80,
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          width: 180,
          align: 'center'
        }
      ]
    }
  },
  computed: {},
  methods: {
    getUserTypeLabel(value, fallbackLabel) {
      const target = value !== null && value !== undefined ? String(value) : ''
      return USER_MONETIZATION_LABEL_MAP[target] || fallbackLabel || '-'
    },
    buildRegisterTimeKey(item) {
      const parts = [
        item.registerTimeCompareType,
        item.registerTimeMin,
        item.registerTimeMax
      ]
      while (
        parts.length &&
        (parts[parts.length - 1] === null ||
          parts[parts.length - 1] === undefined)
      ) {
        parts.pop()
      }
      return parts.join('_')
    },
    async fetchDictionaries() {
      const [registerRes, payRes, langRes, countryRes, channelChildRes, channelParentRes] =
        await Promise.allSettled([
          getRegisterTimeOptions(),
          getDictionaryList({ dictTopic: 'PAY_TYPE' }),
          getLangList({ current: -1, size: -1 }),
          getDictionaryList({ dictTopic: 'GOODS_COUNTRY_GROUP' }),
          getDictionaryList({ dictTopic: 'COLORATION_CHANNEL' }),
          getDictionaryList({ dictTopic: 'COLORATION_CHANNEL_TYPE' })
        ])
      if (registerRes.status === 'fulfilled') {
        const rawOptions = registerRes.value.data || []
        this.registerTimeOptions = rawOptions.map((item) => {
          const key = this.buildRegisterTimeKey(item)
          return { ...item, key, label: item.displayText || key }
        })
      }
      if (payRes.status === 'fulfilled') {
        this.payTypeOptions = payRes.value.data.records || []
      }
      if (langRes.status === 'fulfilled') {
        this.langOptions = langRes.value.data.records || []
      }
      if (
        countryRes.status === 'fulfilled' &&
        countryRes.value.data &&
        countryRes.value.data.records
      ) {
        this.countryLi = countryRes.value.data.records.map((i) => ({
          label: i.dictName,
          value: i.dictName,
          children: i.dictValue.split(',').map((j) => ({
            value: j.split('|')[0],
            label: j.split('|')[1]
          }))
        }))
      }
      if (channelChildRes.status === 'fulfilled' || channelParentRes.status === 'fulfilled') {
        const channelChildren =
          channelChildRes.status === 'fulfilled' && channelChildRes.value.data && channelChildRes.value.data.records
            ? channelChildRes.value.data.records
            : []
        const channelParents =
          channelParentRes.status === 'fulfilled' && channelParentRes.value.data && channelParentRes.value.data.records
            ? channelParentRes.value.data.records
            : []

        let channelData = []
        if (channelParents.length && channelChildren.length) {
          channelData = channelParents.map((parent) => {
            let childValues = []
            try {
              childValues = JSON.parse(parent.dictValue)
            } catch (e) {}
            const children = childValues.map((val) => {
              const childInfo = channelChildren.find((c) => c.dictValue === String(val))
              return { label: childInfo ? childInfo.dictName : val, value: String(val) }
            })
            return {
              label: parent.dictName,
              value: parent.dictName,
              children: children.length ? children : undefined
            }
          })
        } else if (channelChildren.length) {
          channelData = channelChildren.map((i) => ({ label: i.dictName, value: i.dictValue }))
        }
        this.channelOptions = channelData
      }
    },
    async getData(current) {
      if (current) this.page.current = current
      this.tableLoading = true
      try {
        const params = {
          current: this.page.current,
          size: this.page.size
        }
        if (this.searchForm.name) {
          params.name = this.searchForm.name
        }
        if (
          this.searchForm.countryCodes &&
          this.searchForm.countryCodes.length
        ) {
          params.countryCodes = this.searchForm.countryCodes.join(',')
        }
        if (this.searchForm.langIds && this.searchForm.langIds.length) {
          params.langIds = this.searchForm.langIds.join(',')
        }
        if (
          this.searchForm.registerTimeKey &&
          this.searchForm.registerTimeKey.length
        ) {
          params.registerTimeKeys = this.searchForm.registerTimeKey.join(',')
        }
        if (this.searchForm.registerTimeKey) {
          const selected = this.registerTimeOptions.find(
            (o) => o.key === this.searchForm.registerTimeKey
          )
          if (selected) {
            params.registerTimeCompareType = selected.registerTimeCompareType
            params.registerTimeMin = selected.registerTimeMin
            params.registerTimeMax = selected.registerTimeMax
          }
        }
        if (
          this.searchForm.payTypes &&
          this.searchForm.payTypes.length
        ) {
          params.payTypes = this.searchForm.payTypes.join(',')
        }
        if (
          this.searchForm.deviceSys !== null &&
          this.searchForm.deviceSys !== undefined
        ) {
          params.deviceSys = this.searchForm.deviceSys
        }
        if (
          this.searchForm.usageScene !== null &&
          this.searchForm.usageScene !== undefined
        ) {
          params.usageScene = this.searchForm.usageScene
        }
        if (
          this.searchForm.channels !== null &&
          this.searchForm.channels !== undefined &&
          this.searchForm.channels.length
        ) {
          params.channels = this.searchForm.channels.join(',')
        }
        if (
          this.searchForm.todayLogin !== null &&
          this.searchForm.todayLogin !== undefined
        ) {
          params.todayLogin = this.searchForm.todayLogin
        }
        if (
          this.searchForm.userType !== null &&
          this.searchForm.userType !== undefined
        ) {
          params.userType = this.searchForm.userType
        }
        if (
          this.searchForm.vipUser !== null &&
          this.searchForm.vipUser !== undefined
        ) {
          params.vipUser = this.searchForm.vipUser === 1
        }
        const { data } = await getCrowdList(params)
        this.tableData = data.records || []
        this.page.total = data.total || 0
      } catch (error) {
        this.$Message.error('获取列表失败')
      } finally {
        this.tableLoading = false
      }
    },
    async handleOpenEditModal(row) {
      if (row) {
        try {
          this.tableLoading = true
          const { data } = await getCrowdInfo(row.id)
          this.editForm = data
          this.editReadonly = false
          this.editVisible = true
        } catch (error) {
          this.$Message.error('获取详情失败')
        } finally {
          this.tableLoading = false
        }
      } else {
        this.editForm = {}
        this.editReadonly = false
        this.editVisible = true
      }
    },
    async handleView(row) {
      try {
        this.tableLoading = true
        const { data } = await getCrowdInfo(row.id)
        this.editForm = data
        this.editReadonly = true
        this.editVisible = true
      } catch (error) {
        this.$Message.error('获取详情失败')
      } finally {
        this.tableLoading = false
      }
    },
    handleViewUsage(row) {
      this.usageCrowdId = row.id
      this.usageCrowdName = row.name
      this.usageVisible = true
    },
    handleDelete(row) {
      delCrowd(row.id).then(r => {
        this.$Message.success('删除成功')
        this.getData()
      })
    }
  },
  mounted() {
    this.fetchDictionaries()
    this.getData()
  }
}
</script>

<style scoped lang="less">
.header-container {
  margin-bottom: 20px;
}

.search-form {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;

  /deep/ .ivu-select {
    flex: 1;
    min-width: 0;
  }
}

.search-row-bottom {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.table-container {
  flex: 1;
  overflow: auto;
}

.ellipsis-text {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 15px;

  a {
    color: #2d8cf0;
    &:hover {
      color: #57a3f3;
    }
  }
}

.layout-card {
  display: flex;
  flex-direction: column;
  /deep/ .ivu-card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
  }
}
</style>